import { WapSessionCloseReasonQuery } from '../api/interfaces';
import { nortadaLogger } from '../components/common/logger';

const wapSessionCloseReasonQueryMapper = (reason: string): WapSessionCloseReasonQuery => {
  const translations: Record<string, WapSessionCloseReasonQuery> = {
    End: 'END',
    Abandon: 'ABANDON',
    Timeout: 'TIMEOUT',
    'Session in progress': 'NOT_CLOSED_YET'
  };

  return translations[reason] ?? nortadaLogger.critical(`${reason} is unsupported Wap session close reason query.`);
};

export default wapSessionCloseReasonQueryMapper;
